import styled from 'styled-components'

export const Wrapper = styled.div`
  border: 1px solid #d9d9d9;
  background: #f5f5f5;
  padding: 16px;
  margin-top: 16px;
  border-radius: 8px;
  color: #363636;
  display: flex;
  gap: 8px;
  svg {
    margin: 4px 4px 0;
  }
  div > div {
    font-weight: 700;
  }
  div > div + div {
    font-weight: 400;
  }
`
